import {store} from '../store'

export const globalMixin = {
	data() {
		return {
			innerWidth: null,
			emitPlacesData: [],
		}
	},
	created() {
		this.innerWidth = window.innerWidth
		window.addEventListener('resize', this.handleResizeEvent)
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResizeEvent)
	},
	computed: {
		currencySymbol() {
			return localStorage.getItem('currencySymbol') ? localStorage.getItem('currencySymbol') : store.getters['global/currencySymbolGetter']
		},
		isLoggedIn() {
			return localStorage.getItem('api-user-token')
		}
	},
	methods: {
		emitPlaces(emitPlaces) {
			emitPlaces.forEach((place, index) => {
				this.emitPlacesData = this.emitPlacesData.concat(place.cities)
				this.emitPlacesData = this.emitPlacesData.concat(place)
			})
		},
		getURL(route, page, school, filters, language = null) {
			if (language === null) {
				language = JSON.parse(document.getElementsByName('current_language')[0].getAttribute('content'));
			}

			if (language && language.language == 'tr')
				language = null;

			var foundPlace = null
			foundPlace = this.emitPlacesData.find(x => x.key == school.place_id)

			var programType = '';

			programType = filters.program_type;

			if (foundPlace != null) {
				var parsedPlaceSlug = foundPlace.slug.split('/');
				return `${route}/${(language != null ? (language.language + '/') : '')}${parsedPlaceSlug[parsedPlaceSlug.length - 1]}/${school.params.school_name}${filters.duration && page !== 'universities' ? '?duration=' + filters.duration + '&program_start_date=' + filters.program_start_date + '&program_type=' + programType : '?program_start_date=' + filters.program_start_date + '&program_type=' + programType}`;
			} else {
				return `${route}/${(language != null ? (language.language + '/') : '')}${page === 'universities' ? 'university-detail' : 'school-detail'}/${school.slug}${filters.duration && page !== 'universities' ? '?duration=' + filters.duration + '&program_start_date=' + filters.program_start_date + '&program_type=' + programType : '?program_start_date=' + filters.program_start_date + '&program_type=' + programType}`;
			}

		},
		cloneObj(obj) {
			return Object.assign({}, obj)
		},
		renameKey(object, key, newKey) {
			const clonedObj = this.cloneObj(object);
			const targetKey = clonedObj[key];
			delete clonedObj[key];
			clonedObj[newKey] = targetKey;
			return clonedObj;
		},
		handleResizeEvent() {
			this.innerWidth = window.innerWidth
		},
		parseParams(search) {
			return Object.fromEntries(new URLSearchParams(search));
		},
		formatPrice(value) {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		},
		addUrlParameter(name, value) {
			const url = new URL(window.location.href)
			let params = new URLSearchParams(url.search);
			params.set(name, value)
			const newRelativePathQuery = window.location.pathname + '?' + params.toString();
			history.pushState(null, '', newRelativePathQuery);
		},
		deleteUrlParameter(name) {
			const url = new URL(window.location.href);
			let params = new URLSearchParams(url.search);
			params.delete(name);
			const newRelativePathQuery = window.location.pathname + '?' + params.toString();
			history.pushState(null, '', newRelativePathQuery);
		},
		getMonday(d) {
			d = new Date(d);
			const day = d.getDay(),
				diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
			return new Date(d.setDate(diff));
		},
		addWeeksToDate(dateObj, numberOfWeeks) {
			dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
			return dateObj;
		}
	}
}
